import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { Box, Stack, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { useMsal } from "@azure/msal-react";

import SigninButton from "./SigninButton";

import { loginRequest } from "msal";
import { setMicrosoftUser } from "context/features/authSlice";
import { authAPI } from "services/apis.service";
import { useAuth } from "hooks/use-auth.hook";
import { useIsMobile } from "hooks/use-breakpoint-checks.hook";

import CleverImg from "assets/images/clever_icon.svg";
import ClassLinkImg from "assets/images/ClassLink.svg";
import GoogleImg from "assets/images/google_icon.svg";
import OfficeImg from "assets/images/microsoft-logo.png";
import nycLogo from "assets/images/nyc_logo.png";
import { useDispatch } from "react-redux";

export default function ServiceSignin({ handleLoading }) {
  const {
    handleExternalLogin,
    redirectToCleverOAuth,
    redirectToClasslinkOAuth,
    redirecttoNYCOAuth,
  } = useAuth({
    handleLoading,
    toast,
  });
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const { instance, inProgress } = useMsal();

  const googleLogin = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        handleExternalLogin(
          response.access_token,
          "Google",
          authAPI.googleLogin
        );
      } catch (error) {
        console.error(error);
      }
    },
  });

  const handleCustomMicrosoft = async () => {
    try {
      dispatch(setMicrosoftUser(true));
      const loginResponse = await instance.loginPopup(loginRequest);
      const account = loginResponse.account;
      const request = {
        scopes: ["user.read"],
        account: account,
      };
      const accessTokenResponse = await instance.acquireTokenSilent(request);
      await handleExternalLogin(
        accessTokenResponse.accessToken,
        "Microsoft",
        authAPI.microsoftLogin
      );
    } catch (e) {
      console.error(e);
      // Errors are handled inside useAuth, no need to toast here
    }
  };

  return (
    <React.Fragment>
      <Typography variant="body1">
        Use your preferred service to sign in
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "1fr"
            : "repeat(auto-fit, minmax(150px, 1fr))",
          gap: 2,
          mt: 2,
        }}
      >
        <SigninButton onClick={googleLogin} image={GoogleImg} title="Google" />
        <SigninButton
          onClick={handleCustomMicrosoft}
          image={OfficeImg}
          title="Microsoft"
        />
        <SigninButton
          link={redirectToCleverOAuth()}
          image={CleverImg}
          title="Clever"
        />
        <SigninButton
          link={redirectToClasslinkOAuth()}
          image={ClassLinkImg}
          title="ClassLink"
        />
        <SigninButton
          link={redirecttoNYCOAuth()}
          image={nycLogo}
          custom={true}
          sx={{width: "110px", height: 40, objectFit: "contain", borderRadius: "2px"}}
          title="NYC"
        />
      </Box>
    </React.Fragment>
  );
}
